import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Image from "next/image"
import ReCAPTCHA from "react-google-recaptcha";
import { prelimsmock } from "../../components/Service/upscprelimsmocktest";
import NewiconA from "../../assets/images/header/modalnew.png";
import { useRef, useEffect, useState } from "react";
import Link from "next/link";
//import ErrorModal from "../../components/Modal/ErrorModal";
import dynamic from 'next/dynamic';
import {upscprelimsApicheck,upscprelimsApiservice} from "../../components/Service/upscprelims";
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Classroom_form = (props) => {


    const [verified, setverified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalOtp, setModalOtp] = useState(false);
    const [modalOtpstatus, setmodalOtpstatus] = useState(null);
    const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
    const [valuephno, setvaluephno] = useState(undefined);
    const [captchaerror, setcaptchaerror] = useState(undefined);
    const [selectedRadio, setSelectedRadio] = useState();
    const [imgerror, setimgerror] = useState(undefined);
    const [base64ImageToUpload, setbase64ImageToUpload] = useState();
    
    const [last8Digits, setLast8Digits] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [RegMobile,setRegMobile] =useState("");
    const pdfRef = useRef();
    const imageUpload = (e) => {
        
    console.log(e.target.files[0].size);
    
        if ((e.target.files[0].size/600) <= 600){
          document.getElementById("fileindex").value = e.target.files[0].name;
          uploadDocument(e,"image");
        }
        
        else {
          setimgerror(true);
          setTimeout(() => {
            setimgerror(false);
          }, 3000);
          document.getElementById("imagefile").value = "";
        }
      };
      const uploadDocument = async (event, type) => {
        const file = event.target.files[0];
        
        console.log(file);
        const base64 = await convertBase64(file);
        console.log(base64);
        const updloadFile = {
          "name": file.name,
          "type": file.type,
          "content": base64.split(",")[1],
          "base64": base64
        }
      
        if (type == "image") {
          setbase64ImageToUpload(updloadFile);
        } 
      };
    
      const convertBase64 = (file) => {
        console.log(file);
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);
    
          fileReader.onload = () => {
            resolve(fileReader.result);
          };
    
          fileReader.onerror = (error) => {
            reject(error);
          };
        });
      };
    
     
    
    function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
      
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }
      
        return jsonObject;
      }

    const HandleChangeValue = (e) => {
        setSelectedRadio(e.target.value);
        if (e.target.value == 'Online'){
            document.getElementById("branch").value = ''
        }
    };

    function onChange(value) {
        if (value == null) {
          setverified(false);
        }
        else {
          setverified(true);
        }
    }
   
    async function handleOnSubmit(e) {
        e.preventDefault();
        if (verified) {
            const formData = {};
            formData['formType'] = "UPSCprelimsmocktest"; 
            formData['title'] = "SIA UPSC Prelims Mock Test 2025";
            formData['branch'] = props.branchname;
            Array.from(e.currentTarget.elements).forEach(field => {
                if (!field.name) return;
                if (field.type === "radio") {
                    if (field.checked) {
                        formData[field.name] = field.value;
                    }
                } else {
                    formData[field.name] = field.value;
                }
            });
            
             //formData['countryCode'] = "+91";
             formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
             formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
             formData["imageFile"] = base64ImageToUpload;
             formData["photo"] = base64ImageToUpload.base64;
             if(formData["mode"]=='Online')
             {
              formData['branch']='online';
             }
          
             formData['siaregisterno']=String(formData['phoneNo']).slice(-7);
             const transform={fields:{...formData}};
             delete transform.fields["imageFile"];
             delete transform.fields["imagefile"];
            // delete transform.fields['filename'];
             console.log(formData);
             upscprelimsApicheck({'phoneNo':formData['phoneNo']})
             .then((response) => {
               console.log("API Response:", response.message);
              // setErrorMsg("");
               if(response.success===false)
               {
                  alert(response.message);
                  //setErrorMsg(true);
                  window.grecaptcha.reset(setverified);
                  setverified(false);
              }
              else
              {
              
              console.log(transform);
              upscprelimsApiservice(formData);
             setIsLoading(true);
             prelimsmock(transform)
                .then(response => {
                  console.log(response);
                    setModalOtp(true);
                   
                   
                    setmodalOtpstatus(response.message);
                    window.grecaptcha.reset(setverified);
                    setverified(false);
                    
                    setvaluephno(undefined);
                    document.getElementById("allindiaprelims").reset();
                    setIsLoading(false);
                    
                    
                  
                })
                .catch(error => {
                    setModalOtp(true);
                    setmodalOtpstatus("failure");
                    setmodalOtpExceptionMessage(error.message.split("Error: ")[1]);
                    window.grecaptcha.reset(setverified);
                    setverified(false);
                    setIsLoading(false);
                })
              }
              });
           

        }
        else {
            setcaptchaerror(true);
            setTimeout(() => {
                setcaptchaerror(false);
            }, 3000);
        }
    }
   
    return (
        <>
               {/*<ErrorModal show={errorMsg}  onHide={() => setErrorMsg(false)} /> */}
            {isLoading &&
                <div class="APIPreLoader" id="APIPreLoader">
                    <div class="loader">Loading...</div>
                </div>
            }
            <Otpverification show={modalOtp} title={modalOtpstatus} exceptionMessage={modalOtpExceptionMessage} frompage="UPSCprelimsmocktest" onHide={() => setModalOtp(false)} />
            <div className="container-fluid pt-3">
                <div className="row mx-auto pt-3" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>
                    <div className="col">

                    <div className="container pt-4">

                        <div className="row">

                            <div className="col-12 mx-auto">
                                <h2 className={`${styles.contactheader}`}>Registration Details&nbsp;&nbsp;&nbsp;<span className={`${styles.acheiverrank2} mb-0`} style={{color: '#DB1B0D'}}>Registration is mandatory to attend the SIA All India UPSC Prelims Mock Test 2025</span></h2>
                                <form onSubmit={handleOnSubmit} id="allindiaprelims" autoComplete="off">

                                    <div className="row pt-4">

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="text" className={`${styles.acheiverrank1} form-control`} placeholder="Name" autoComplete="off" name="name" minLength="1" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="email" className={`${styles.acheiverrank1} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="tel" className={`${styles.acheiverrank1} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">

                                            <label className={`${styles.acheiverrank1} form-check-label px-2`}>Mode</label>
                                            <input className="form-check-input" type="radio"
                                                name="mode"
                                                value={"Online"}
                                                id="Online"
                                                required
                                                onChange={HandleChangeValue}
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Online"> Online</label>
                                            <input className="form-check-input" type="radio"
                                                name="mode"
                                                value={"Offline"}
                                                id="Offline"
                                                required
                                                onChange={HandleChangeValue}
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Offline">Offline</label>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">
                                        <div className="mb-4">
                                            <select disabled={selectedRadio ===  'Online' ? 'Offline' : ''} className={`${styles.acheiverrank} form-select form-control`} id="branch" name="branch" autoComplete="off" required>
                                            <option value="" selected>Select Center</option>
                                            <option value="Chennai-Annanagar">Annanagar</option>
                                            <option value="Chennai-Adyar">Adyar</option>
                                            <option value="Delhi">Delhi</option>
                                            <option value="Bengaluru">Bengaluru</option>
                                            <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                                            <option value="Hyderabad">Hyderabad</option>
                                            <option value="Meghalaya">Meghalaya</option>
                                            <option value="Shimla">Shimla</option> 
                                            <option value="Kashmir">Kashmir</option> 
                                            <option value="Trichy">Trichy</option>
                                            <option value="Salem">Salem</option>
                                            <option value="Madurai">Madurai</option>                                         
                                            <option value="Coimbatore">Coimbatore</option>
                                            </select>
                                        </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">
                                        <div className="mb-4">
                                        <select className={`${styles.acheiverrank} form-select form-control`} name="optionalForCsm" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Choose your Optionals for CSM</option>
                                            <option value="Economics">Economics</option>
                                            <option value="Geography">Geography</option>
                                            <option value="Indian History">Indian History</option>
                                            <option value="Philosophy">Philosophy</option>
                                            <option value="Political Science">Political Science</option>
                                            <option value="Psychology">Psychology</option>
                                            <option value="Public Administration">Public Administration</option>
                                            <option value="Sociology">Sociology</option><option value="Law">Law</option>
                                            <option value="Agriculture">Agriculture</option>
                                            <option value="Animal Husbandry and Veterinary Science">Animal Husbandry and Veterinary Science</option><option value="Botany">Botany</option>
                                            <option value="Chemistry">Chemistry</option>
                                            <option value="Mathematics">Mathematics</option>
                                            <option value="Statistics">Statistics</option>
                                            <option value="Medical Science">Medical Science</option>
                                            <option value="Physics">Physics</option>
                                            <option value="Zoology">Zoology</option>
                                            <option value="Anthropology">Anthropology</option>
                                            <option value="Geology">Geology</option>
                                            <option value="Civil Engineering">Civil Engineering</option>
                                            <option value="Electrical Engineering">Electrical Engineering</option><option value="Mechanical Engineering">Mechanical Engineering</option>
                                            <option value="Commerce">Commerce</option>
                                            <option value="Management">Management</option>
                                            <option value="Literature">Literature</option>
                                            </select>
                                        </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">
                                        <div className="mb-4">
                                          <select className={`${styles.acheiverrank} form-select form-control`} name="associationWithSiaProgram" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Association with SIA Program?</option>
                                            <option value="GS-PCM">GS-PCM</option>
                                            <option value="GS-Preliminary">GS-Preliminary</option>
                                            <option value="Prestorming">Prestorming</option>
                                            <option value="Prefit">Prefit</option>
                                            <option value="Mains Crash Course">Mains Crash Course</option>
                                            <option value="Mainstorming">Mainstorming/Moksha</option>
                                            <option value="New To SIA">New To SIA</option>
                                            <option value="Others">Others</option>
                                            </select>
                                        </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                            <label htmlFor="exampleInputPhno" className={`${styles.acheiverrank1}  form-label mb-0`}>Passport size photo<span className={`${styles.formstar}`}>*</span></label>               
                                                <div className="input-group d-block">
                                                    <div className="form-group">
                                                      <div className="input-group">
                                                        <input type="text" id="fileindex" title="Please select a file" name="filename" className="form-control" readOnly required style={{ display: 'none' }} />
                                                        <span className="input-group-btn" style={{ border: "1px solid #D9DFE6", borderTopRightRadius: "0.375rem", borderBottomRightRadius: "0.375rem" }}>
                                                          <div className={`${styles.customFileUploader} btn btn-default`}  onSubmit="return Checkfiles(this);">
                                                            <input type="file" className={`${styles.selected}`} name="imagefile" id="imagefile" onChange={e => imageUpload(e)} accept="image/x-png,image/jpeg" required />
                                                            Select File
                                                          </div>
                                                        </span>
                                                        <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                                                            Img size should be less than 300 KB and in .jpg, .jpeg, .png format               
                                                      </label>
                                                      
                                                      </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    {imgerror && <div className="text-danger pt-1 captachafont">Please select a photo upto a size of 300 KB</div>}
                                                </div>
                                            </div>
                                        </div>

                                       
                                        
                                        <div className="col-12  pt-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                                            <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                                                I would like to receive updates from Shankar IAS Academy
                                            </label>
                                        </div>


                                        <div className="d-flex flex-wrap mb-3">
                                            <div className="me-3 mt-2">
                                                <ReCAPTCHA className={`${styles.captcha}`}
                                                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                                    onChange={onChange}

                                                />
                                                <div className="">
                                                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                                                </div>
                                            </div>

                                            <div className="my-auto">
                                                <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                                            </div>

                                            <div className="my-auto mx-auto text-end">  
                                              <p className={`${styles.aboutparagraph3} p-1`}><Link href="/upsc-prelims-hallticket" rel="noreferrer" target="_blank" className={`${styles.program}`}><span><Image src={NewiconA} width="15" height="15" alt="New_icon" className="img-fluid mx-2" /></span>Download UPSC Prelims Mock Test Hall Ticket (Click Here) </Link></p>
                                            </div>
                                        </div>
                                       
                                    </div>

                                    </div>
                                   
                                    

                                </form>

                            </div>

                        </div>
  {/* Show Submitted Data 
  <form onSubmit={downloapdfsubmit}>
  Enter Mobile number
  <input type="tel" name='mobileNumber' id="mobileNumber" required value={RegMobile} onChange={(e) => setRegMobile(e.target.value)}/>
  <button class={`${styles.normalbutton}`} type="submit">Send</button>
  </form>
  <button
          type="button"
          onClick={generatePDF}
          className="bg-blue-500 text-white p-2 rounded mt-4"
        >
          Generate PDF
        </button>
        
  {submittedData && (
        <div ref={pdfRef} className="mt-6 p-4 border rounded-lg bg-gray-100 w-full">
          <h2 className="text-lg font-semibold">Submitted Data:</h2>
          <p><strong>Name:</strong> {submittedData.name}</p>
          <p><strong>sia registerno:</strong> {submittedData.sia_registerno}</p>
          <p><strong>Email:</strong> {submittedData.email}</p>
          <p><strong>Phone:</strong> {submittedData.phone_no}</p>
          <p><strong>Mode:</strong> {submittedData.center}</p>
          <p><strong>Center:</strong> {submittedData.branch}</p>
          <p><strong>optional_csm:</strong> {submittedData.optional_csm}</p>
          <p><strong>sia_association:</strong> {submittedData.sia_association}</p>
         
            <img
              src={submittedData.passport_photo}
              alt="Uploaded"
              className="mt-2 w-32 h-32 object-cover border rounded"
            />
        
        </div>
      )} */}
                    </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Classroom_form;